import React, { Component } from 'react'
import { connect } from 'react-redux'
import Collapse from 'react-css-collapse';
import classname from 'classnames'
import { updateTab, updatePopup, updatePopupTab } from '../../../actions/editordashboard'
import { getAdminSubmission, updateAdminSubmissionInput } from '../../../actions/Admin'
//import Autocomplete from 'react-predictive-input';
import TopNav from '../../includes/TopNav.js';
import { getAdminUserCollection } from '../../../actions/AdminUserCollection'
import { getAdminDocument, updateAdminDocumentInput, patchAdminDocument, sendReminderEmail, ADMIN_QUICK_ACCEPT_EMAIL } from '../../../actions/AdminDocument'
import { getAdminUser, updateAdminUserInput } from '../../../actions/AdminUser'
import { uploadPaper } from '../../../actions/paper';
import config from '../../../config/config.json'
import { Link } from 'react-router-dom'
import moment from 'moment'
import {getFormattedTime, docStatusToString, hasEsl} from '../../../util/displayUtils.js';
import "react-predictive-input/src/component/scss/styles.scss";

class AdminDocument extends Component {
  constructor(props) {
    super(props);
    this.state = {eslCollapsed: false, receipt: false};
  }
  componentDidMount() {
    this.getAdminDocument();
    this.getAdminUserCollection();
  }
  uploadPaper(paper) {
    this.props.dispatch(uploadPaper(paper, this.props.AdminDocument.pricing, this.props.AdminDocument.paper));
  }
  postPaper() {
    // this.props.dispatch(postSubmission(this.props.Paper.paper))
  }
  triggerUpload(e) {
      document.querySelector('.upload-file').click()
  }
  getAdminUserCollection() {
    // this.props.dispatch(getAdminUserCollection(() => {
    // }))
    this.props.dispatch(getAdminUserCollection());

  }
  sendReminderEmail(){
    this.props.dispatch(sendReminderEmail(this.props.AdminDocument.doc, () => {
    }))
  }
  patchAdminDocument() {
    this.props.dispatch(patchAdminDocument(this.props.AdminDocument.doc, this.props.match.params.DocId, () => {
    }))
  }
  patchAdminDocumentWithEditor(editor, noAlert) {
    console.log("actual editor " + this.props.AdminDocument.doc.email);
    var editor_body = {};
    editor_body.changeEditor = 1;
    for (var i = 0; i < this.props.AdminUserCollection.editors.length; i++) {
      if(this.props.AdminDocument.doc.email === this.props.AdminUserCollection.editors[i].email){
        editor_body.user_id = this.props.AdminUserCollection.editors[i].user_id;
        editor_body.email = this.props.AdminUserCollection.editors[i].email;
      }
    }
    console.log("CHECKING ON EDITOR BODY ", editor_body);
    this.props.dispatch(patchAdminDocument(editor_body, this.props.match.params.DocId, () => {
    }, noAlert))
  }
  getAdminDocument() {
    this.props.dispatch(getAdminDocument(this.props.match.params.DocId, () => {
    }))
  }
  updateAdminDocumentInput(key, e) {
    console.log("going to update document input");
    if(e.target){
        this.props.dispatch(updateAdminDocumentInput(key, e.target.value))
    }else if (e) {
        this.props.dispatch(updateAdminDocumentInput(key, e))
    }
    // this.props.dispatch(updateAdminDocumentInput(key, e.target.value))
    // <p className="small">{this.props.AdminDocument.doc}</p>
  }
  toggleEslView(){
    var newState = {eslCollapsed: !this.state.eslCollapsed}
    this.setState(newState);
  }
  hasEsl(eslType) {
    if(this.props.AdminDocument.doc && this.props.AdminDocument.doc.extras) {
      return hasEsl(this.props.AdminDocument.doc.extras, eslType);
    }
    return false;
  }
  switchView(view) {
    var newState = {receipt: false}
    if(view === 'receipt') {
      newState.receipt = true;
    }
    this.setState(newState);
  }
  quickAccept() {
    this.updateAdminDocumentInput('doc_status', 2);
    this.updateAdminDocumentInput('email', ADMIN_QUICK_ACCEPT_EMAIL);
    var editor;
    this.patchAdminDocumentWithEditor(editor, true);
    this.patchAdminDocument();
  }
  render() {
    var address, state, zipcode;

    if(this.props.AdminDocument.doc.receipt_location) {
      var addressParts = this.props.AdminDocument.doc.receipt_location.split(' : ');
      if(addressParts.length > 0) {
        address = addressParts[0];
        state   = addressParts[1];
        zipcode = addressParts[2];
    
      }  
    }
    var edit_path1;
    if(this.props.AdminDocument.doc.edit_path1){
      edit_path1  = <div><br/><a href={config.BASE + this.props.AdminDocument.doc.edit_path1}>Download Edited</a></div>
    }
    var edit_path2;
    if(this.props.AdminDocument.doc.edit_path2){
      edit_path2 = <div><br/><a href={config.BASE + this.props.AdminDocument.doc.edit_path2}>Download Final</a></div>
    }
    let editors = [];
    for (var i = 0; i < this.props.AdminUserCollection.editors.length; i++) {
      editors[i] = this.props.AdminUserCollection.editors[i].email;
    }
    var editorsOptions = editors.map((val, key) => {
      var isSelected = false;
      if(val == this.props.AdminDocument.doc.email) {
        isSelected = true;
      }
      return <option selected={isSelected} key={key} value={val}>{val}</option>
    });
    // = this.props.AdminUserCollection.editors;
    let students =this.props.AdminUserCollection.students;
    var wordCount = classname({ 'easing': true, 'wordCount': true ,'visible': true })
    var couponCode = this.props.AdminDocument.doc.receipt_coupon_code;
    if(couponCode == 'mybalance') {
      couponCode = 'Balance used: ';
    }
    return(
      <div>
        <TopNav />
        <br/><br/>
        <section id="admin-container">
          <div style={{textAlign: 'center'}} >
            <button onClick={this.switchView.bind(this, 'details')}>Details</button>&nbsp;
            <button onClick={this.switchView.bind(this, 'receipt')}>Receipt</button>
          </div>
          <div className={this.state.receipt? 'hidden': 'admin-form'}>
            <h3 className="small-header">{this.props.AdminDocument.doc.user_email} - {this.props.AdminDocument.doc.doc_name}</h3>
            <table>
              <tbody>
                <tr>
                  <th></th>
                  <th>Original</th>
                  <th>Edited</th>
                  <th>Final</th>
                </tr>
                <tr>
                  <td>Name</td>
                  <td>{this.props.AdminDocument.doc.doc_name}</td>
                  <td>{this.props.AdminDocument.doc.file_name1}</td>
                  <td>{this.props.AdminDocument.doc.file_name2}</td>
                </tr>
                <tr>
                  <td>Upload Date</td>
                  <td colSpan="3">{getFormattedTime(this.props.AdminDocument.doc.upload_date)}</td>
                </tr>
                <tr>
                  <td>Due Date</td>
                  <td colSpan="3">{getFormattedTime(this.props.AdminDocument.doc.due_date)}</td>
                </tr>
                <tr>
                  <td>Time Limit</td>
                  <td colSpan="3">
                    <select type="text" className="small-select" value={this.props.AdminDocument.doc.time_limit} onChange={this.updateAdminDocumentInput.bind(this, 'time_limit')}>
                      <option value="1.5">1.5 hours</option>
                      <option value="3">3 hours</option>
                      <option value="7">7 hours</option>
                      <option value="12">12 hours</option>
                      <option value="24">24 hours</option>
                      <option value="72">72 hours</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>wordCount</td>
                  <td colSpan="3">{this.props.AdminDocument.doc.word_count}</td>
                </tr>
                <tr>
                  <td>Download</td>
                  <td><a href={config.BASE + this.props.AdminDocument.doc.doc_path} target="_blank">Download</a></td>
                  <td><a href={config.BASE + this.props.AdminDocument.doc.edit_path1}>Download Edited</a></td>
                  <td><a href={config.BASE + this.props.AdminDocument.doc.edit_path2}>Download Final</a></td>
                </tr>
                <tr>
                  <td>Status</td>
                  <td colSpan="3">
                    <select className="small-select" type="text" value={this.props.AdminDocument.doc.doc_status} onChange={this.updateAdminDocumentInput.bind(this, 'doc_status')}>
                      <option value="0">0 - {docStatusToString(0)}</option>
                      <option value="1">1 - {docStatusToString(1)}</option>
                      <option value="2">2 - {docStatusToString(2)}</option>
                      <option value="3">3 - {docStatusToString(3)}</option>
                      <option value="4">4 - {docStatusToString(4)}</option>
                    </select>
                    <button onClick={this.quickAccept.bind(this)} style={{'marginLeft': '40px'}}>Accept</button>
                  </td>
                </tr>
                <tr>
                  <td>Level</td>
                  <td colSpan="3">
                    <select type="text" className="small-select" value={this.props.AdminDocument.doc.editor_level} onChange={this.updateAdminDocumentInput.bind(this, 'editor_level')}>
                      <option value="bronze">Bronze</option>
                      <option value="silver">Silver</option>
                      <option value="gold">Gold</option>
                      <option value="pro">Pro</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>Doc Cost</td>
                  <td colSpan="3">{this.props.AdminDocument.doc.doc_cost}</td>
                </tr>
                <tr>
                  <td>Actual Charge (coupon), pre-tax</td>
                  <td colSpan="3">{this.props.AdminDocument.doc.receipt_total_amount}</td>
                </tr>
                <tr>
                  <td>Tax Amount</td>
                  <td colSpan="3">{this.props.AdminDocument.doc.receipt_tax}</td>
                </tr>
                {(this.props.AdminDocument.doc.receipt_coupon_code)?
                <tr>
                  <td>Coupon code + amount</td>
                  <td colSpan="3">{couponCode} {this.props.AdminDocument.doc.receipt_coupon}</td>
                </tr>
                :<tr></tr>
                }
                <tr>
                  <td>Instructions File</td>
                  <td colSpan="3">
                  {(this.props.AdminDocument.doc.instructions_file_name)?
                    <span><a href={config.BASE + this.props.AdminDocument.doc.instrunctions_file_path + '/' + this.props.AdminDocument.doc.instructions_file_name} target="_blank">Download</a></span>
                    :
                    <span></span>
                    }
                  </td>
                </tr>
              </tbody>
            </table>
            <h3 className="small-header">Edit Details:</h3>
            <table>
              <tbody>
                <tr>
                  <td>Accepted At</td>
                  <td>{this.props.AdminDocument.doc.date_accepted}</td>
                </tr>
                <tr>
                  <td>Completed At</td>
                  <td>{this.props.AdminDocument.doc.date_completed}</td>
                </tr>
                <tr>
                  <td>Edited by</td>
                  <td>
                    <select onChange={this.updateAdminDocumentInput.bind(this, 'email')}>
                    <option></option>
                     {editorsOptions}
                    </select>
                    {/*<Autocomplete
                    id="editor_email_value"
                    onSelected={this.updateAdminDocumentInput.bind(this, 'email')}
                      value={this.props.AdminDocument.doc.email}
                      className="editor-form-autocomplete"
                      placeholder={this.props.AdminDocument.doc.email}
                      data={editors}
                    /> */}
                    <button onClick={this.patchAdminDocumentWithEditor.bind(this)}>Apply</button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div>
              <button onClick={this.toggleEslView.bind(this)}>ESL</button>
            </div>
          
            <Collapse isOpen={this.state.eslCollapsed}>
            <fieldset>

            {/* TODO - fix binding so they get saved in extras.[something] */}
            <legend className="small">ESL</legend>
              <p className="flex">
              <input type="radio" checked={this.hasEsl("ESL")} value="1" onChange={this.updateAdminDocumentInput.bind(this, 'esl')}/> Yes
              <input type="radio" checked={!this.hasEsl("ESL")} value="0" onChange={this.updateAdminDocumentInput.bind(this, 'esl')}/> No
              </p>

              <p className="small">Extra Editing</p>
              <p className="flex">
              <input type="radio" checked={this.hasEsl("ExtraEditing")} value="1" onChange={this.updateAdminDocumentInput.bind(this, 'extraEditing')}/> Yes
              <input type="radio" checked={!this.hasEsl("ExtraEditing")} value="0" onChange={this.updateAdminDocumentInput.bind(this, 'extraEditing')}/> No
              </p>

              <p className="small">Extra Comments</p>
              <p className="flex">
              <input type="radio" checked={this.hasEsl("extraComments")}  value="1" onChange={this.updateAdminDocumentInput.bind(this, 'extraComments')}/> Yes
              <input type="radio" checked={!this.hasEsl("extraComments")} value="0" onChange={this.updateAdminDocumentInput.bind(this, 'extraComments')}/> No
              </p>
              <p className="small">Grade Paper</p>
              <p className="flex">
              <input type="radio" checked={this.hasEsl("gradeMyPaper")}  value="1" onChange={this.updateAdminDocumentInput.bind(this, 'gradeMyPaper')}/> Yes
              <input type="radio" checked={!this.hasEsl("gradeMyPaper")} value="0" onChange={this.updateAdminDocumentInput.bind(this, 'gradeMyPaper')}/> No
              </p>

              <p className="small">Critiques</p>
              <p className="flex">
              <input type="radio" checked={this.hasEsl("Critiques")}  value="1" onChange={this.updateAdminDocumentInput.bind(this, 'critiques')}/> Yes
              <input type="radio" checked={!this.hasEsl("Critiques")} value="0" onChange={this.updateAdminDocumentInput.bind(this, 'critiques')}/> No
              </p>

              <p className="small">Formatting</p>
              <p className="flex">
              <input type="radio" checked={this.hasEsl("Formatting")}  value="1" onChange={this.updateAdminDocumentInput.bind(this, 'formatting')}/> Yes
              <input type="radio" checked={!this.hasEsl("Formatting")} value="0" onChange={this.updateAdminDocumentInput.bind(this, 'formatting')}/> No
              </p>

              <p className="small">Plagiarism</p>
              <p className="flex">
              <input type="radio" checked={this.hasEsl("Plagiarism")}  value="1" onChange={this.updateAdminDocumentInput.bind(this, 'plagiarism')}/> Yes
              <input type="radio" checked={!this.hasEsl("Plagiarism")} value="0" onChange={this.updateAdminDocumentInput.bind(this, 'plagiarism')}/> No
              </p>

              <p className="small">Citation Correction</p>
              <p className="flex">
              <input type="radio" checked={this.hasEsl("CitationCorrection")}  value="1" onChange={this.updateAdminDocumentInput.bind(this, 'citationCorrection')}/> Yes
              <input type="radio" checked={!this.hasEsl("CitationCorrection")} value="0" onChange={this.updateAdminDocumentInput.bind(this, 'citationCorrection')}/> No
              </p>

              {/* currently blocked in 4step process 
              <p className="small">Citation #</p>
              <input type="number" className="tiny-select" value={this.props.AdminDocument.doc.citations} onChange={this.updateAdminDocumentInput.bind(this, 'citations')}/>

              <p className="small">Citation Style</p>
              <select type="text" className="tiny-select" value={this.props.AdminDocument.doc.citationStyle} onChange={this.updateAdminDocumentInput.bind(this, 'citationStyle')}>
                <option value="">Select a style</option>
                <option value="APA">APA</option>
                <option value="MLA">MLA</option>
                <option value="Chicago">Chicago</option>
              </select> */}
            </fieldset>
            </Collapse>
            <h3 className="small-header">Instructions</h3>
            <textarea className="small-text-area" value={this.props.AdminDocument.doc.instructions} onChange={this.updateAdminDocumentInput.bind(this, 'instructions')}>
              {this.props.AdminDocument.doc.instructions || 'N/A'}
            </textarea>

            <br/><br/><br/>
            <div className="small-admin-input">
              <span>
                <Link to="/admindashboard">Back</Link><br/>
                <button className="load-more" onClick={this.sendReminderEmail.bind(this)}>Send Reminder</button><br/>
                <button className="load-more" onClick={this.patchAdminDocument.bind(this)}>Update Document</button>
              </span>
            </div>
          </div>
          <div className={this.state.receipt? 'admin-form' : 'hidden'}>
              <div><span className="receiptItem">Word Count:</span> {this.props.AdminDocument.doc.word_count}</div>
              <div><span className="receiptItem">Pages:</span> {this.props.AdminDocument.doc.receipt_pages}</div>
              <div><span className="receiptItem">Cost Per Page:</span> {this.props.AdminDocument.doc.receipt_cost_per}</div>
              <div><span className="receiptItem">Editor Level:</span> {this.props.AdminDocument.doc.editor_level}</div>
              <div><span className="receiptItem">ESL:</span> 0 (not saved separately to DB yet)</div>
              <div><span className="receiptItem">ESL2:</span> 0 (not saved separately to DB yet)</div>
              <div><span className="receiptItem">Extra Comments:</span> 0 (not saved separately to DB yet)</div>
              <div><span className="receiptItem">Formatting:</span> 0 (not saved separately to DB yet)</div>
              <div><span className="receiptItem">Critiques:</span> 0 (not saved separately to DB yet)</div>
              <div><span className="receiptItem">Coupon Code:</span> 0 (implemented?)</div>
              <div><span className="receiptItem">Coupon Amount:</span> 0 (implemented?)</div>
              <div><span className="receiptItem">Total Amount:</span> {this.props.AdminDocument.doc.receipt_total_amount}</div>
              <div><span className="receiptItem">Tax %:</span> {this.props.AdminDocument.doc.receipt_tax/this.props.AdminDocument.doc.receipt_total_amount*100}</div>
              <div><span className="receiptItem">Tax Added:</span> {this.props.AdminDocument.doc.receipt_tax}</div>
              <div><span className="receiptItem">Country/Province:</span> {state}</div>
              <div><span className="receiptItem">Address:</span> {address}, {zipcode}</div>
              <div><span className="receiptItem">IP Address:</span> {this.props.AdminDocument.doc.receipt_ip}</div>
              <div><span className="receiptItem">Payment Method:</span> {this.props.AdminDocument.doc.receipt_payment_type}</div>
          </div>
        </section>
        </div>
    )
  }
}

export default connect( ({Dashboard, AdminDocument, AdminUserCollection}) => ({Dashboard, AdminDocument, AdminUserCollection}) ) (AdminDocument)
// <Autocomplete
//    placeholder={"Type Name" || this.props.AdminDocument.doc.doc_status}
//    data={editors}
//    caseSensitive={false}
//    onSelected={this.updateAdminDocumentInput.bind(this, 'studentemail')} />



// WEBPACK FOOTER //
// ./src/components/dashboards/AdminDashboard/AdminDocument.js